import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-successfully',
  templateUrl: './user-successfully.component.html',
  styleUrls: ['./user-successfully.component.scss']
})
export class UserSuccessfullyComponent implements OnInit {

  userID: any;
  page:any;
    show: boolean=false;
    constructor( private route: ActivatedRoute,) { }
  
    ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        const id = +params.user_id;
        this.page = params.p
        if (id > 0) {
         console.log(id);
         this.userID = id;
        }
        if(this.page=="superAdmin"){
          this.show=true;
        }
      });
    }
  
  }
  